// extracted by mini-css-extract-plugin
export default {"adWrapper":"_ads_adWrapper__t5o2A","img":"_ads_img__JloOZ","indicatorContentWrp":"_ads_indicatorContentWrp__sEASz"};